import { render, staticRenderFns } from "./BottomTable.vue?vue&type=template&id=61c89eb1&scoped=true"
import script from "./BottomTable.vue?vue&type=script&lang=js"
export * from "./BottomTable.vue?vue&type=script&lang=js"
import style0 from "./BottomTable.vue?vue&type=style&index=0&id=61c89eb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c89eb1",
  null
  
)

export default component.exports